import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../app-config.service.service';

@Injectable({
  providedIn: 'root'
})
export class OpenRifService {
  private baseurl = "";
  private apiroute = "";

  constructor(
    private http: HttpClient,
    private appSetting: AppConfigService,
  ) {
    this.baseurl = this.appSetting.apiBaseUrl;
    this.apiroute = '/FlexIntegration';
  }

  GetRfiById(id){
    console.log({method: 'Get_OpenRFIById', id: id})
    return this.http.post<any>(this.baseurl + this.apiroute, {method: 'Get_OpenRFIById', id: id});
  }

  GetAllRfiById(id){
    // let obj = {method: 'Get_OpenRFIAllByProjectId', id: id}
    let obj = {method: 'Get_RFIByProjectIdCE', projectid: id}
    console.log(obj)
    return this.http.post<any>(this.baseurl + this.apiroute, obj);
  }

  InsertRfi(docname, rfinumber, projectid, lastupdated, contactid, priorityid, assignto, respondbydate, needresponse, rfiresponse, description, id ){
    let obj2 = {
      method: 'Insert_ProjectRFI',
      docname: docname,
      rfinumber: rfinumber,
      projectid: projectid,
      lastupdated: lastupdated, 
      assignto: assignto,
      priorityid: priorityid,  
      contactid: contactid,
      respondbydate: respondbydate,
      needresponse: needresponse,
      rfiresponse: rfiresponse,
      description: description,
      id: id, 
    }
    console.log(obj2);
    return this.http.post<any>(this.baseurl + this.apiroute, obj2);
  }

  GetEmployees(){
    return this.http.post<any>(this.baseurl + this.apiroute, {method: 'Get_EmployeeListAll'});
  }

  GetContacts(name){
    return this.http.post<any>(this.baseurl + '/Contacts/Get_AllContactsByName', {name: name});
  }

  GetContacts2(){
    return this.http.post<any>(this.baseurl + this.apiroute, {method: 'Get_ContactsAll'})
  }

  GetDocuments(id){
    let obj = {method:'GetPunchItemsAttachment', id: id}
    console.log(obj)
    return this.http.post<any>(this.baseurl + this.apiroute, obj);
  }

  InsertDocument(opeitemid, attachment, description, createbyid, deleted, id){
    let obj = {
      method: 'InsertUpdateOpenItemAttachment',
      opeitemid: opeitemid,
      attachment: attachment,
      description: description,
      createbyid: createbyid,
      deleted: deleted,
      id: id,
    }
    console.log(obj);
    return this.http.post<any>(this.baseurl + '/ServiceSitePunch', obj);
  }

}
